module.exports = __webpack_public_path__ + "media/images/page/contract_ic-5a88122f3b384e1ba976300fbed96464.svg";